<!--  -->
<template>
<div class=''>
    <Nav :navList="navList"></Nav>
    <transition name="el-zoom-in-top">
      <!-- <div v-if="franchiseData==undefined||Object.keys(franchiseData).length==0" v-show="show" style="width:100%;height:100%;color:brown">
        {{ message }}
      </div> -->
      <div v-loading="loading" v-show="show" class="franchise-container">
        <el-image v-if="franchiseData.backImg" class="franchiseBg" :src="franchiseData.backImg" fit="cover"></el-image>
        <div class="franchise-content">
          <div class="info-cards">
          <div class="info">
            <h1>联系我们</h1>
            <div class="infoBorder"></div>
            <div class="message"><img src="@/assets/加盟信息/主机.png"/><span>{{franchiseData.telephone}}</span></div>
            <div class="message"><img src="@/assets/加盟信息/定位.png"/><span>{{franchiseData.address}}</span></div>
          </div>
          <div class="info">
            <h1>联系我们</h1>
            <div class="infoBorder"></div>
            <div class="message"><img src="@/assets/加盟信息/电话.png"/><span>{{franchiseData.mobilePhone}}</span></div>
            <div class="message"><img src="@/assets/加盟信息/邮件.png"/><span>{{franchiseData.email}}</span></div>
          </div>
            <div class="info qr-info">
            <h1>联系我们</h1>
            <div class="infoBorder"></div>
            <div v-if="franchiseData.qrCode" class="message qr-code"><img :src="franchiseData.qrCode"/></div>
          </div>
        </div>
        </div>
      </div>
    </transition>  
</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import Nav from "@/components/Nav"
import {query} from '@/api/web/franchise'
// import {loadingTime} from '@/utils/const.js'
export default {
//import引入的组件需要注入到对象中才能使用
components: {Nav},
data() {
//这里存放数据
return {
navList:["加盟信息"],
franchiseData:{},
show:false,
loading:true
};
},
//监听属性 类似于data概念
computed: {},
//监控data中的数据变化
watch: {},
//方法集合
methods: {

},
//生命周期 - 创建完成（可以访问当前this实例）
created() {

},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {
 this.show=true
 var _this = this
//  setTimeout(()=>{
//   if(Object.keys(_this.franchiseData).length==0||_this.franchiseData==undefined||_this.franchiseData==null){
//     _this.message='获取加盟信息失败,请刷新页面重试'
//   }
//  },loadingTime)
 query().then((res)=>{
  const data = res && res.data ? res.data : {}
  if(Object.keys(data).length==0||data==undefined||data==null){
      _this.$message.error("加盟信息加载失败,请刷新页面重试!")
  }
  _this.franchiseData = data
  _this.loading=false
 },()=>{
  _this.$message.error("加盟信息加载失败,请刷新页面重试!")
  _this.loading=false
 })
},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
/** scoped 表示 样式自在当前组件有效*/

.franchise-container {
  width: 100%;
  height: 100%;
  
  @media screen and (max-width: 768px) {
    overflow-y: auto;
  }
}

.info-cards {
  display: flex;
  justify-content: space-around;
  width: 75%;
  margin-top: 80px;
  
  @media screen and (max-width: 1024px) and (min-width: 769px) {
    width: 90%;
    flex-wrap: wrap;
  }
  
  @media screen and (max-width: 768px) {
    display: flex !important;
    flex-direction: column !important;
    width: 100% !important;
    margin-top: 30px !important;
    padding: 0 15px !important;
    box-sizing: border-box;
    gap: 20px;
  }
}

.info{
  display:flex;
  flex-direction:column;
  align-items: flex-start;
  width:25%;
  
  @media screen and (max-width: 1024px) and (min-width: 769px) {
    width: 40%;
    margin-bottom: 30px;
  }
  
  @media screen and (max-width: 768px) {
    display: flex !important;
    flex-direction: column !important;
    align-items: flex-start !important;
    width: 100% !important;
    margin-bottom: 0 !important;
    padding: 20px !important;
    background: #f9f9f9 !important;
    border-radius: 10px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  }
}

.info h1 {
  @media screen and (max-width: 768px) {
    font-size: 16px;
  }
}

.infoBorder{
  border-bottom:4px solid black;
  padding:0px;
  width:70px;
  
  @media screen and (max-width: 768px) {
    width: 40px;
  }
}

.qr-info {
  @media screen and (max-width: 768px) {
    align-items: center;
    
    .infoBorder {
      align-self: center;
    }
  }
}

.message{
  margin-top:25px;
  width:100%;
  height: 50px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  
  @media screen and (max-width: 768px) {
    margin-top: 12px;
    height: auto;
    flex-wrap: wrap;
  }
}

.message:first-child {
  margin-top: 50px;
  
  @media screen and (max-width: 768px) {
    margin-top: 15px;
  }
}

.message span{
  width:90%;
  height:50px;
  line-height: 50px;
  font-size: 20px;
  margin-left: 20px;
  text-align:justify;
  word-break: keep-all;
  
  @media screen and (max-width: 1024px) and (min-width: 769px) {
    font-size: 16px;
  }
  
  @media screen and (max-width: 768px) {
    font-size: 13px;
    line-height: 1.5;
    height: auto;
    width: 100%;
    margin-left: 8px;
    word-break: break-all;
  }
}

.message img{
  width:30px;
  height:35px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  
  @media screen and (max-width: 768px) {
    width: 20px;
    height: 24px;
    flex-shrink: 0;
  }
}

.qr-code {
  margin-top: 58px;
  justify-content: flex-start;
  
  @media screen and (max-width: 768px) {
    margin-top: 20px;
    justify-content: center;
  }
}

.qr-code img{
  width:160px;
  height:160px;
  margin-top: 120px;
  
  @media screen and (max-width: 1024px) and (min-width: 769px) {
    width: 120px;
    height: 120px;
    margin-top: 60px;
  }
  
  @media screen and (max-width: 768px) {
    width: 100px;
    height: 100px;
    margin-top: 15px;
  }
}

.franchiseBg{
  width:100%;
  height:460px;
  border-radius:0px 0px 25px 25px;
  
  @media screen and (max-width: 768px) {
    height: 250px;
    border-radius: 0;
    object-fit: cover;
  }
}

.franchise-content {
  display: flex;
  justify-content: center;
}
</style>
